/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropdownOptionParam } from './DropdownOptionParam';
import {
    DropdownOptionParamFromJSON,
    DropdownOptionParamFromJSONTyped,
    DropdownOptionParamToJSON,
    DropdownOptionParamToJSONTyped,
} from './DropdownOptionParam';

/**
 * 
 * @export
 * @interface UpdateDropdownOptionsRequest
 */
export interface UpdateDropdownOptionsRequest {
    /**
     * 
     * @type {Array<DropdownOptionParam>}
     * @memberof UpdateDropdownOptionsRequest
     */
    options: Array<DropdownOptionParam>;
}

/**
 * Check if a given object implements the UpdateDropdownOptionsRequest interface.
 */
export function instanceOfUpdateDropdownOptionsRequest(value: object): value is UpdateDropdownOptionsRequest {
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function UpdateDropdownOptionsRequestFromJSON(json: any): UpdateDropdownOptionsRequest {
    return UpdateDropdownOptionsRequestFromJSONTyped(json, false);
}

export function UpdateDropdownOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDropdownOptionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'options': ((json['options'] as Array<any>).map(DropdownOptionParamFromJSON)),
    };
}

export function UpdateDropdownOptionsRequestToJSON(json: any): UpdateDropdownOptionsRequest {
    return UpdateDropdownOptionsRequestToJSONTyped(json, false);
}

export function UpdateDropdownOptionsRequestToJSONTyped(value?: UpdateDropdownOptionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'options': ((value['options'] as Array<any>).map(DropdownOptionParamToJSON)),
    };
}

